import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { AdminapiService } from 'src/app/shared/services/adminapi.service';
import { WebapiService } from 'src/app/shared/services/webapi.service';
import { CustomValidators } from 'src/app/shared/validators/CustomValidators';
import { AppState } from 'src/app/store/app.states';
import { getAdminUserInfo } from 'src/app/store/selector/selector';

declare var bootstrap: any;
declare var $: any;  

@Component({
  selector: 'app-admin-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit,OnChanges {
  @Input() user:any;
  @Input() modalid:any;
  @Output() newItemEvent = new EventEmitter<string>();
  submitting=false;
  maxBirthdayDate = new Date();
  countries:any=[];

  Form: FormGroup = this.fb.group({
    oldpassword: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
    password: ['', Validators.compose([Validators.minLength(8)])],
    first_name: ['', Validators.compose([Validators.required])],
    last_name: ['', Validators.compose([Validators.required])],
    dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
    country: ['', Validators.compose([Validators.required])],
    gym_name: [''],
    number_of_coaches: [''],
    number_of_athletes: [''],
    form_type:['']
  });

  constructor(private fb: FormBuilder,private store: Store<AppState>, private toastrService: ToastrService, public adminApi: AdminapiService, public webApi: WebapiService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(this.user){
      // this.maxBirthdayDate = new Date(this.user.dob);
      // this.maxBirthdayDate.setFullYear( this.maxBirthdayDate.getFullYear() - 18 );
      this.initForm()
    }
  }

  ngOnInit()  
  {    
    this.getCountries()
  } 

  addNewItem(value: string) {
    this.newItemEvent.emit(value);
  }

  
  initForm(){
    this.Form = this.fb.group({
      first_name: ['', Validators.compose([Validators.required])],
      last_name: ['', Validators.compose([Validators.required])],
      dob: ['', Validators.compose([Validators.required, CustomValidators.noFutureDateValidator])],
      country: ['', Validators.compose([Validators.required])],
      gym_name: ['', (this.user.role=="gymowner" || this.user.role=="choreographer")?Validators.compose([Validators.required]):null],
      form_type:['']
    });

    this.Form.patchValue({
      first_name: this.user.first_name,
      last_name: this.user.last_name,
      dob: new Date(this.user.dob),
      country: this.user.country,
      gym_name:this.user.gym_name,
      form_type:this.user.role
    });
  }

  onSubmit(form: FormGroup) {
    if (form.valid && !this.submitting) {
      this.submitting = true;
      if(this.user){
        form.value.id=this.user.id
      }
      form.value.dob = this.webApi.formatDate(form.value.dob)
      this.adminApi.editUser(form.value).subscribe((data: any) => {
        if (data.success) {
          this.addNewItem('change')
					this.toastrService.success(data.message);
          $('#'+this.modalid).modal('hide');
          //this.webApi.setSession(data);
          //this.router.navigateByUrl('/');
        } else {
					this.toastrService.error(data.message);
        }
        this.submitting = false;
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.submitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f2(): { [key: string]: AbstractControl } {
    return this.Form.controls;
  }

  getCountries(){
    this.webApi.getCountries().subscribe((data: any) => {
      if (data.success) {
        this.countries=data.countries;
        //this.webApi.setSession(data);
        //this.router.navigateByUrl('/');
        
      } else {
        alert(data.message)
      }
    },
    error => {
      this.toastrService.error("unable to handle response");
    });
  }


  
}


